import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const Loader: React.FC<{ open: boolean }> = ({ open }) => (
  <Backdrop
    open={open}
    sx={{
      zIndex: 10,
      height: '100vh',
    }}
  >
    <CircularProgress color="secondary" />
  </Backdrop>
);

export default Loader;
